import axios from "axios";
import sha256 from "crypto-js/sha256";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Config from "../../../Config";
import {
  color_green_dark,
  color_grey_light,
  color_red_default,
  color_red_warning,
} from "../../../constants/colors";
import { validatePhone } from "../../../utilities/validatePhone";
import { useI18n } from "../../../i18n/I18nProvider";
import ModalQuestion from "../../blocks/ModalQuestion";
import ModalSimple from "../../blocks/ModalSimple";
import { FormPhoneInput } from "../../inputs/FormTextInput/FormPhoneInput";
import {
  AuthField,
  AuthFields,
  AuthForm,
  AuthFormHeader,
  AuthFormRow,
  AuthFormSubtitle,
  AuthFormTitle,
  AuthPrimaryButton,
  AuthSecondaryButton,
  ConsentCheckbox,
  ConsentRow,
  PhoneFieldWrap,
  RegisterFormShell,
  RegisterHelper,
} from "./AuthForm.styles";

const EMAIL_DOMAIN_NOT_ALLOWED =
  "Этот домен недоступен для регистрации. Укажите другой адрес электронной почты.";

const getApiErrorStatus = (err) => err?.response?.status ?? err?.status;

const getApiErrorDetail = (err) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail.message === "string") return detail.message;
  return "";
};

export const FormCheckBox = ({ onChange, value }) => {
  const handleChange = useCallback(
    (e) => {
      onChange(e);
      console.log("checkbox", e.target.checked);
    },
    [onChange],
  );

  return (
    <div>
      <label
        htmlFor="test"
        style={{
          boxShadow: "1px 0 4px 0 rgba(178, 178, 178, 0.29)",
          border: `1px solid ${color_grey_light}`,
          borderRadius: 5,
          width: 25,
          height: 25,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {value ? (
          <svg
            width="11"
            height="9"
            viewBox="0 0 11 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 0.75L3.625 7.625L0.5 4.5"
              stroke="#E12F2F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : null}
      </label>
      <input
        style={{
          position: "absolute",
          zIndex: -1,
          opacity: 0,
        }}
        id="test"
        type="checkbox"
        checked={value}
        onChange={handleChange}
      />
    </div>
  );
};

const RegisterForm = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("+");
  const [email, setEmail] = useState("");
  //const [timeZone, setTimeZone] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState("");
  const [isAgree, setIsAgree] = useState("");
  const [pinHash, setPinHash] = useState("");
  const [pinSentToEmail, setPinSentToEmail] = useState("");
  const [pin, setPin] = useState("");
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);
  const [isEmailMatch, setIsEmailMatch] = useState(false);
  const [referredBy, setReferredBy] = useState("");
  const [isreferalByMatch, setIsReferredByMatch] = useState(null);

  const [isModalSimpleOpen, setIsModalSimpleOpen] = useState(false);
  const [modalSimpleContent, setModalSimpleContent] = useState("");
  const [modalSimpleTitle, setModalSimpleTitle] = useState("");
  const [modalSimpleType, setModalSimpleType] = useState("error");
  const [modalSimpleButtonText, setModalSimpleButtonText] = useState("");
  const handleCloseModalSimple = useCallback(() => {
    setIsModalSimpleOpen(false);
    setModalSimpleButtonText("");
  }, []);

  const [isModalQuestionOpen, setIsModalQuestionOpen] = useState(false);
  const [modalQuestionContent, setModalQuestionContent] = useState("");
  const [modalQuestionTitle, setModalQuestionTitle] = useState("");
  const [modalQuestionType, setModalQuestionType] = useState("info");
  const [isEmailSending, setIsEmailSending] = useState(false);

  const handleCloseModalQuestion = useCallback((answer) => {
    if (!answer) {
      navigate("/auth/login");
    }
    setIsModalQuestionOpen(false);
  }, []);

  const handleNameChange = useCallback(
    (e) => {
      setName(e.target.value);
    },
    [name],
  );

  const handlePhoneChange = useCallback((e) => {
    setPhone(e.target.value);
  }, []);

  const handleReferredByChange = useCallback((e) => {
    setReferredBy(e.target.value);
    if (e.target.value.length === 6) {
      axios
        .get(
          Config.BACKEND_ADDR + "/auth/is_exist_referal_code/" + e.target.value,
        )
        .then((response) => {
          if (response.status === 200) {
            setIsReferredByMatch(response.data);
          }
        });
    } else {
      setIsReferredByMatch(false);
      if (e.target.value.length === 0) {
        setIsReferredByMatch(null);
      }
    }
  }, []);

  const handleEmailChange = useCallback(
    (e) => {
      const next = e.target.value;
      const nextNorm = next.trim().toLowerCase();
      const sentNorm = pinSentToEmail.trim().toLowerCase();
      const sameAsSent = sentNorm !== "" && nextNorm === sentNorm;

      setEmail(next);
      setIsEmailMatch(
        Boolean(
          next.match(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          ),
        ),
      );

      if (sameAsSent) {
        return;
      }

      setPinHash("");
      setPin("");
      setIsEmailConfirmed(false);
      setPinSentToEmail("");
    },
    [pinSentToEmail],
  );
  /* 
    
        const handleTimeZoneChange = useCallback((e) => {
            setTimeZone(e.target.value);
        }, [timeZone]);
     */
  const handleNewPasswordChange = useCallback(
    (e) => {
      setNewPassword(e.target.value);
    },
    [newPassword],
  );

  const handleNewPasswordRepeatChange = useCallback(
    (e) => {
      setNewPasswordRepeat(e.target.value);
    },
    [newPasswordRepeat],
  );

  const handleCheckChange = useCallback(
    (e) => {
      setIsAgree(e.target.checked);
    },
    [isAgree],
  );

  useEffect(() => {
    const phoneValidation = validatePhone(phone);
    setIsNeedUpdate(
      name !== "" &&
        phone !== "" &&
        email !== "" &&
        newPassword !== "" &&
        newPasswordRepeat !== "" &&
        isAgree === true &&
        isEmailConfirmed === true &&
        newPassword === newPasswordRepeat &&
        (isreferalByMatch === true ||
          (referredBy.length === 0 && isreferalByMatch === null)) &&
        phoneValidation.valid,
    );
  }, [
    name,
    phone,
    email,
    newPassword,
    newPasswordRepeat,
    isAgree,
    isEmailConfirmed,
    isreferalByMatch,
    referredBy.length,
  ]);

  const loginSubmit = () => {
    let backendAddr = Config.BACKEND_ADDR + "/auth/user"; // /api

    if (isAgree === false) {
      setModalSimpleContent(
        t("Необходимо согласие на обработку персональных данных"),
      );
      setModalSimpleTitle(t("Внимание"));
      setModalSimpleType("alert");
      setIsModalSimpleOpen(true);
      setModalSimpleButtonText(t("Хорошо"));
      return;
    }

    setIsLoading(true);
    if (newPassword.length < 6 || newPassword !== newPasswordRepeat) {
      setModalSimpleContent("");
      setModalSimpleTitle(
        t("Пароли должны совпадать и длинна быть 6 символов или больше."),
      );
      setModalSimpleType("alert");
      setIsModalSimpleOpen(true);
      setModalSimpleButtonText(t("Хорошо"));
      return;
    }
    axios
      .put(
        backendAddr,
        {
          email: email,
          full_name: name,
          phone_number: phone,
          password: newPassword,
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          referred_by: referredBy,
        },
        { withCredentials: true },
      )
      .then((response) => {
        if (response.status === 201) {
          (async () => {
            let uuid = await localStorage.getItem("uid");
            if (!uuid) {
              uuid = uuidv4();
              await localStorage.setItem("uid", uuid);
            }
            const loginUUid = await axios.post(
              Config.BACKEND_ADDR + "/devices/login_device",
              { uuid },
            );
            console.log("Login UUID response:", loginUUid);
            navigate("/auth/tariffs");
          })();
        } else {
          setModalSimpleContent(t("Попробуйте ещё раз"));
          setModalSimpleTitle(
            `${t("Произошла ошибка")} ${response.status} ${t("при подключении к серверу")}`,
          );
          setModalSimpleType("alert");
          setModalSimpleButtonText(t("Хорошо"));
          setIsModalSimpleOpen(true);
        }
      })
      .catch((err) => {
        const status = getApiErrorStatus(err);
        if (status === 409) {
          setModalQuestionContent(
            t("Если вы уже создавали аккаунт, войдите в систему через форму авторизации."),
          );
          setModalQuestionTitle(t("Такой email уже зарегистрирован"));
          setModalQuestionType("error");
          setIsModalQuestionOpen(true);
        } else if (status === 400) {
          setModalSimpleTitle(t("Некорректный email"));
          setModalSimpleContent(
            t(getApiErrorDetail(err) || EMAIL_DOMAIN_NOT_ALLOWED),
          );
          setModalSimpleType("error");
          setModalSimpleButtonText(t("Хорошо"));
          setIsModalSimpleOpen(true);
        } else {
          if (status !== 201) {
            setModalSimpleContent(
              err.message || t("Произошла ошибка при регистрации."),
            );
            setModalSimpleTitle(t("Ошибка"));
            setModalSimpleType("error");
            setIsModalSimpleOpen(true);
          }
        }
      });
  };

  const handleConfirmEmail = async () => {
    if (isEmailSending) return;

    if (!isEmailMatch) {
      setModalSimpleContent("");
      setModalSimpleTitle(t("Некорректный email"));
      setModalSimpleType("error");
      setIsModalSimpleOpen(true);
      return;
    }

    setIsEmailSending(true);
    try {
        const res = await axios.post(
          Config.BACKEND_ADDR + "/support/confirmation/email",
          { email: email },
        );
        if (res.status === 200) {
          const nextPinHash = res.data?.pinHash;
          if (nextPinHash) {
            setPinHash(nextPinHash);
            setPinSentToEmail(email);
          }
          setModalSimpleTitle(
            t("Мы отправили проверочный код на вашу электронную почту"),
          );
          setModalSimpleContent(
            t("Проверьте почту и введите код для продолжения регистрации"),
          );
          setModalSimpleButtonText(t("Хорошо"));
          setModalSimpleType("success");
        } else if (res.status === 409) {
          setModalQuestionContent(
            t("Если вы уже создавали аккаунт, войдите в систему через форму авторизации"),
          );
          setModalQuestionTitle(t("Такой email уже зарегистрирован"));
          setModalQuestionType("error");
          setIsModalQuestionOpen(true);
          setIsEmailConfirmed(false);
          setPinHash("");
          setPinSentToEmail("");
          setEmail("");
        } else if (res.status === 400) {
          setModalSimpleTitle(t("Некорректный email"));
          setModalSimpleContent(
            t(
              typeof res.data?.detail === "string"
                ? res.data.detail
                : EMAIL_DOMAIN_NOT_ALLOWED,
            ),
          );
          setModalSimpleButtonText(t("Хорошо"));
          setModalSimpleType("error");
        } else if (res.status === 550) {
          setModalSimpleTitle(t("Ошибка отправки email"));
          setModalSimpleContent(
            t("Указанный email недоступен или не существует. Проверьте почту и повторите попытку"),
          );
          setModalSimpleButtonText(t("Хорошо"));
          setModalSimpleType("error");
        } else {
          setModalSimpleTitle(t("Упс"));
          setModalSimpleContent(
            t("Похоже, код не отправился. Нажмите «Подтвердить почту» ещё раз."),
          );
          setModalSimpleButtonText(t("Хорошо"));
          setModalSimpleType("error");
        }
        setIsModalSimpleOpen(true);
    } catch (err) {
      if (err.response && err.response.status === 409) {
        setModalQuestionContent(
          t("Если вы уже создавали аккаунт, войдите в систему через форму авторизации"),
        );
        setModalQuestionTitle(t("Такой email уже зарегистрирован"));
        setModalQuestionType("error");
        setIsModalQuestionOpen(true);
        setIsEmailConfirmed(false);
        setPinHash("");
        setPinSentToEmail("");
        setEmail("");
      } else if (err.response && err.response.status === 400) {
        setModalSimpleTitle(t("Некорректный email"));
        setModalSimpleContent(
          t(getApiErrorDetail(err) || EMAIL_DOMAIN_NOT_ALLOWED),
        );
        setModalSimpleButtonText(t("Хорошо"));
        setModalSimpleType("error");
        setIsModalSimpleOpen(true);
      } else if (err.response && err.response.status === 550) {
        setModalSimpleTitle(t("Ошибка отправки email"));
        setModalSimpleContent(
          t("Указанный email недоступен или не существует. Проверьте почту и повторите попытку"),
        );
        setModalSimpleButtonText(t("Хорошо"));
        setModalSimpleType("error");
        setIsModalSimpleOpen(true);
      } else {
        setModalSimpleTitle(t("Упс"));
        setModalSimpleContent(
          t("Похоже, код не отправился. Нажмите «Подтвердить почту» ещё раз."),
        );
        setModalSimpleButtonText(t("Хорошо"));
        setModalSimpleType("error");
        setIsModalSimpleOpen(true);
      }
    } finally {
      setIsEmailSending(false);
    }
  };
  const handleConfirmPin = async (pin) => {
    setPin(pin.target.value);
    if (pin.target.value.length === 6) {
      if (pinHash !== "") {
        if (sha256(pin.target.value).toString() === pinHash) {
          setIsEmailConfirmed(true);
          setModalSimpleContent("");
          setModalSimpleTitle(t("Email успешно подтвержден"));
          setModalSimpleType("success");
          setIsModalSimpleOpen(true);
        } else {
          setIsEmailConfirmed(false);
          setModalSimpleContent(t("Неверный PIN-код"));
          setModalSimpleTitle(t("Ошибка подтверждения email"));
          setModalSimpleType("error");
          setIsModalSimpleOpen(true);
        }
      } else {
        setModalSimpleContent("");
        setModalSimpleTitle(t("Необходимо подтвердить email"));
        setModalSimpleType("alert");
        setIsModalSimpleOpen(true);
      }
    }
  };

  const referralStatus = (() => {
    switch (true) {
      case isreferalByMatch === false && referredBy.length === 6:
        return { color: color_red_warning, text: t("Некорректный реферальный код") };
      case referredBy.length !== 6 && referredBy.length > 0:
        return {
          color: color_red_warning,
          text: t("Реферальный код должен содержать 6 символов"),
        };
      case isreferalByMatch === true && referredBy.length === 6:
        return { color: color_green_dark, text: t("Реферальный код подтвержден") };
      default:
        return {
          color: color_grey_light,
          text: t("Если нет реферального кода, оставьте поле пустым"),
        };
    }
  })();

  const phoneError =
    phone &&
    phone.replace(/\D/g, "").length > 0 &&
    !validatePhone(phone).valid
      ? validatePhone(phone).error
      : null;

  return (
    <RegisterFormShell>
      <ModalSimple
        type="none"
        h2={modalSimpleTitle}
        p={modalSimpleContent}
        isOpen={isModalSimpleOpen}
        onClose={handleCloseModalSimple}
        buttonText={modalSimpleButtonText || t("Закрыть")}
      />
      <ModalQuestion
        type="none"
        h2={modalQuestionTitle}
        p={modalQuestionContent}
        isOpen={isModalQuestionOpen}
        onClose={handleCloseModalQuestion}
        yesText={t("Закрыть")}
        noText={t("Авторизоваться")}
        isButtonRevers={false}
      />

      <AuthForm as="div" $compact>
        <AuthFormHeader $compact>
          <AuthFormTitle>{t("Регистрация")}</AuthFormTitle>
          <AuthFormSubtitle>{t("Создайте аккаунт преподавателя")}</AuthFormSubtitle>
        </AuthFormHeader>

        <AuthFields>
          <AuthFormRow
            $columns="minmax(0, 1.45fr) minmax(170px, 0.8fr)"
            $align={pinHash ? "start" : "end"}
          >
            <div>
              <AuthField>
                E-mail
                <input
                  placeholder={t("Введите Email")}
                  type="email"
                  value={email}
                  disabled={isEmailConfirmed || Boolean(pinHash)}
                  autoComplete="email"
                  onChange={handleEmailChange}
                />
              </AuthField>
              {isEmailConfirmed && (
                <RegisterHelper $color={color_green_dark}>{t("Email подтвержден")}</RegisterHelper>
              )}
            </div>
            {!pinHash ? (
              <AuthSecondaryButton
                type="button"
                disabled={!isEmailMatch || isEmailSending}
                onClick={handleConfirmEmail}
              >
                {isEmailSending ? t("Отправляем...") : t("Подтвердить почту")}
              </AuthSecondaryButton>
            ) : (
              <AuthField>
                {t("Введите PIN-код")}
                <input
                  placeholder="000000"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]{6}"
                  value={pin}
                  disabled={isEmailConfirmed}
                  onChange={handleConfirmPin}
                />
              </AuthField>
            )}
          </AuthFormRow>

          <AuthFormRow>
            <AuthField>
              {t("Имя и фамилия")}
              <input
                placeholder={t("Введите имя и фамилию")}
                type="text"
                value={name}
                autoComplete="name"
                onChange={handleNameChange}
              />
            </AuthField>
            <PhoneFieldWrap>
              <FormPhoneInput
                type="tel"
                title={t("Номер телефона")}
                value={phone}
                onChange={handlePhoneChange}
                width="100%"
              />
              {phoneError && (
                <RegisterHelper $color={color_red_default}>{t(phoneError)}</RegisterHelper>
              )}
            </PhoneFieldWrap>
          </AuthFormRow>

          <AuthFormRow>
            <AuthField>
              {t("Введите пароль")}
              <input
                placeholder={t("Пароль")}
                type="password"
                value={newPassword}
                autoComplete="new-password"
                onChange={handleNewPasswordChange}
              />
            </AuthField>
            <AuthField>
              {t("Повторите пароль")}
              <input
                placeholder={t("Повторите пароль")}
                type="password"
                value={newPasswordRepeat}
                autoComplete="new-password"
                onChange={handleNewPasswordRepeatChange}
              />
            </AuthField>
          </AuthFormRow>

          <div>
            <AuthField>
              {t("Реферальный код (если есть)")}
              <input
                placeholder="xxxxxx"
                type="text"
                value={referredBy}
                onChange={handleReferredByChange}
              />
            </AuthField>
            <RegisterHelper $color={referralStatus.color}>
              {referralStatus.text}
            </RegisterHelper>
          </div>

          <ConsentRow>
            <ConsentCheckbox>
              <input
                type="checkbox"
                checked={Boolean(isAgree)}
                onChange={handleCheckChange}
              />
              {isAgree && (
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
                  <path
                    d="M10.5 0.75L3.625 7.625L0.5 4.5"
                    stroke="#E12F2F"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </ConsentCheckbox>
            <span>
              {t("Я даю")}{" "}
              <a href="/personal-data-agreement.html">
                {t("согласие на обработку персональных данных")}
              </a>
            </span>
          </ConsentRow>

          <AuthPrimaryButton
            type="button"
            disabled={!isNeedUpdate || isLoading}
            onClick={loginSubmit}
          >
            {isLoading ? t("Регистрируем...") : t("Зарегистрироваться")}
          </AuthPrimaryButton>
        </AuthFields>
      </AuthForm>
    </RegisterFormShell>
  );
};

export default RegisterForm;
